module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_b/og-aoj_b-e6c289e5304aa0c34415208631ea9db4.png";